import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
const effect = new effectManager();

export default class linkLineHover{
    constructor(){

        /* 必要なDOM */
        this.$trigger = $(".c-line__hover");

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            device : "pc",
        }


    }
    init() {

        let _this = this;

        this.$trigger.on("mouseenter",function () {

            _this.mouseOn($(this));

        }).on("mouseleave",function () {

            _this.mouseOut($(this));

        });

    }

    mouseOn($this){
        let _$line = $this.find(".c-line__hover-target-line");
        TweenMax.killTweensOf(_$line);
        TweenMax.to(_$line,0.9,{
            "x" : 100 + "%",
            ease: Power2.easeInOut
        });
        TweenMax.to(_$line,0.4,{
            "opacity":1,
            ease: Power2.easeIn
        });
    }
    mouseOut($this){
        let _$line = $this.find(".c-line__hover-target-line");
        TweenMax.killTweensOf(_$line);
        TweenMax.to(_$line,0.9,{
            "x" : -100 + "%",
            ease: Power2.easeInOut
        });
        TweenMax.to(_$line,0.4,{
            "opacity":0,
            delay : 0.4,
            ease: Power2.easeOut
        });
    }
    motion(mode){



    }

    resize(){
        let _w = window.innerWidth;
        if(_w>param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }
    }
}